import { __assign, __rest } from "tslib";
import React from 'react';
import c from 'classnames';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import s from './FooterRowLayout.scss';
var FooterRowLayout = function (_a) {
    var blocks = _a.blocks, className = _a.className, rest = __rest(_a, ["blocks", "className"]);
    return (React.createElement("div", __assign({ className: c(s['root'], className), "data-hook": BiDataHook.COMMENT_FOOTER }, rest), blocks));
};
FooterRowLayout.displayName = 'FooterRowLayout';
export default FooterRowLayout;
//# sourceMappingURL=FooterRowLayout.js.map